import { createAsyncThunk } from "@reduxjs/toolkit";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { contactSettingsApi } from "service/contactSettingsApi";

export const getContactSettings = createAsyncThunk(
  "getContactSettings",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await contactSettingsApi.getSettings();
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const createContactSettings = createAsyncThunk(
  "createContactSettings",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await contactSettingsApi.createSettings(payload);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return data.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);

export const updateContactSettings = createAsyncThunk(
  "updateContactSettings",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await contactSettingsApi.updateSettings(payload);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return data.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error?.response?.data?.message || error.message);
    }
  }
);
